import { capitalize } from 'es-toolkit';
import { type PlanType } from '@/types';
import { Chip, type ChipProps } from '@/ui_v3/components/chip/Chip';
import { cn } from '@/utils';
type PlanChipProps = ChipProps & {
  plan: PlanType;
};
export const PlanChip = (props: PlanChipProps) => {
  const {
    className,
    plan,
    ...rest
  } = props;
  return <Chip {...rest} size="xs" className={cn(rest.onClick ? 'cursor-pointer' : 'cursor-default', plan === 'FREE' && ['bg-neutral border-black/[0.08] text-neutral', rest.onClick && 'hover:bg-gray-200'], plan === 'PRO' && ['border-opacity-assistive text-strong bg-violet-50', rest.onClick && 'hover:bg-violet-100'], plan === 'BASIC' && ['border-opacity-assistive text-positive bg-green-50', rest.onClick && 'hover:bg-green-100'], className)} data-sentry-element="Chip" data-sentry-component="PlanChip" data-sentry-source-file="PlanChip.tsx">
      {capitalize(plan)}
    </Chip>;
};